import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { LiteralsState } from '../../reducers/literals.reducer';
import * as selectors from '../../selectors/literals/schemas.literals.selectors';

@Injectable({
  providedIn: 'root',
})
export class SchemasLiteralsFacadeService extends FacadeService {
  constructor(public override store: Store<LiteralsState>) {
    super(store);
  }

  // OBSERVABLES
  schemaCode$ = this.storeSelect(selectors.getSchemaCode);
  companyName$ = this.storeSelect(selectors.getCompanyName);
  vatNumber$ = this.storeSelect(selectors.getVATNumber);
  schemaName$ = this.storeSelect(selectors.getSchemaName);
  company$ = this.storeSelect(selectors.getCompany);
  redemptionThreshold$ = this.storeSelect(selectors.getRedemptionThreshold);
  printedCards$ = this.storeSelect(selectors.getPrintedCards);
  invoices$ = this.storeSelect(selectors.getInvoices);
  sortCreationDate$ = this.storeSelect(selectors.getSortCreationDate);
  sortSchemaCode$ = this.storeSelect(selectors.getSortSchemaCode);
  sortSchemaName$ = this.storeSelect(selectors.getSortSchemaName);
  updateSchemaInfo$ = this.storeSelect(selectors.getUpdateSchemaInfo);
  defaultCountry$ = this.storeSelect(selectors.getDefaultCountry);
  chooseCompany$ = this.storeSelect(selectors.getChooseCompany);
  orCreate$ = this.storeSelect(selectors.getOrCreate);
  schemaLevel$ = this.storeSelect(selectors.getSchemaLevel);
  nexusAccount$ = this.storeSelect(selectors.getNexusAccount);
  redemptionType$ = this.storeSelect(selectors.getRedemptionType);
  usePrintedCards$ = this.storeSelect(selectors.getUsePrintedCards);
  useInvoices$ = this.storeSelect(selectors.getUseInvoices);
  ticketsEmailForward$ = this.storeSelect(selectors.getTicketsEmailForward);
  ticketsEmailSenderName$ = this.storeSelect(selectors.getTicketsEmailSenderName);
  welcomeKitsEmailForward$ = this.storeSelect(selectors.getWelcomeKitsEmailForward);
  welcomeKitsMinSize$ = this.storeSelect(selectors.getWelcomeKitsMinSize);
  welcomeKitsMaxSize$ = this.storeSelect(selectors.getWelcomeKitsMaxSize);
  choosePassword$ = this.storeSelect(selectors.getChoosePassword);
  verifyPassword$ = this.storeSelect(selectors.getVerifyPassword);
  ticketsConfiguration$ = this.storeSelect(selectors.getTicketsConfiguration);
  welcomeKitsConfiguration$ = this.storeSelect(selectors.getWelcomeKitsConfiguration);
  password$ = this.storeSelect(selectors.getPassword);
  newCompany$ = this.storeSelect(selectors.getNewCompany);
  country$ = this.storeSelect(selectors.getCountry);
  taxOffice$ = this.storeSelect(selectors.getTaxOffice);
  webSiteURL$ = this.storeSelect(selectors.getWebSiteURL);

  // OBSERVABLE'S VALUES
  get schemaName() {
    return this.storeSnapshot(this.schemaName$);
  }

  get schemaCode() {
    return this.storeSnapshot(this.schemaCode$);
  }

  get company() {
    return this.storeSnapshot(this.company$);
  }

  get redemptionThreshold() {
    return this.storeSnapshot(this.redemptionThreshold$);
  }

  get printedCards() {
    return this.storeSnapshot(this.printedCards$);
  }

  get invoices() {
    return this.storeSnapshot(this.invoices$);
  }

  get sortCreationDate() {
    return this.storeSnapshot(this.sortCreationDate$);
  }

  get sortSchemaCode() {
    return this.storeSnapshot(this.sortSchemaCode$);
  }

  get sortSchemaName() {
    return this.storeSnapshot(this.sortSchemaName$);
  }
}
